const data = {
  func: {
    title: "场景解决方案",
    subtitle: "全场景覆盖",
    bg:
      "https://img14.360buyimg.com/imagetools/jfs/t1/113624/8/19967/946333/5f83fe71E9dd67322/b7c50d9976768722.png",
  },
  style: {},
  data: {
    getData: {
      data: {
        data: [
          {
            title: "办公集采场景",
            subtitle:
              "实现了企业采购价格全国一体化，利于统一管控，有效降低采购成本，让采购阳光透明、高效便捷、质优价良。",
            icon:
              "https://img13.360buyimg.com/imagetools/jfs/t1/134532/16/11891/410/5f817fc1E42134f4f/0a20dc0cad496136.png",
            bg:
              "https://img13.360buyimg.com/imagetools/jfs/t1/157965/36/6302/57795/601cae20Eadeb3d4a/33f3a2ec17f8a5ef.jpg",
          },
          {
            title: "员工福利场景",
            subtitle:
              "线上采购，缩短采购周期，提高效率；内部福利，商品种类丰富，提升员工满意度。积分兑换场景中支持混合支付服务。",
            icon:
              "https://img14.360buyimg.com/imagetools/jfs/t1/153283/21/1840/851/5f817fc1Ebe56f59d/73bb07a8e9507f9d.png",
            bg:
              "https://img11.360buyimg.com/imagetools/jfs/t1/164025/33/5645/42029/601cae20E0f639905/a29522d9cd3000d2.jpg",
          },
          {
            title: "渠道奖励场景",
            subtitle:
              "帮助企业建立完善的渠道成长体系，制定销售激励策略，实现激励形式多元化、激励触达高效化、激励管理人性化，从而达到提升企业渠道及销售人员的激励效果以及满意度的目标。",
            icon:
              "https://img14.360buyimg.com/imagetools/jfs/t1/138505/39/10446/598/5f817fc1E9a20331c/f1162256e20ce2c9.png",
            bg:
              "https://img11.360buyimg.com/imagetools/jfs/t1/154900/32/17349/24788/601cae20E2c579f8d/785312a475d79221.jpg",
          },
          {
            title: "市场活动场景",
            subtitle:
              "市场人员为了促进终端客户的活跃度、粘度，在售卖各类险种的同时，能给予多种商品做为赠品，进行捆绑式销售。",
            icon:
              "https://img10.360buyimg.com/imagetools/jfs/t1/136049/30/11797/756/5f817fc1E20474290/4ac63cf723208fa1.png",
            bg:
              "https://img13.360buyimg.com/imagetools/jfs/t1/166016/4/5157/77701/601cae20Ef67ff657/11731da5327234aa.jpg",
          },
          {
            title: "虚拟业务场景",
            subtitle:
              "为企业提供电子E卡、PLUS会员、话费、企悦服务、机票、领货码购买能力，为核心客户提供更优质的购物体验。",
            icon:
              "https://img14.360buyimg.com/imagetools/jfs/t1/128646/1/14679/396/5f817fc2E8aa61c0f/11f744ede1ebde1c.png",
            bg:
              "https://img10.360buyimg.com/imagetools/jfs/t1/164398/28/5592/45298/601cae20E56197255/323ff30069999513.jpg",
          },
          {
            title: "平台合作场景",
            subtitle:
              "将京东的商城技术能力进行模块化的解耦并输出，同时输出商务及运营服务能力帮助线上平台类合作伙伴链接京东的商品流、物流、内容流、金融服务等电商基础服务能力，快速具备商城运营能力。",
            icon:
              "https://img12.360buyimg.com/imagetools/jfs/t1/163294/16/5659/504/601caeebE36e40d2f/1a47444f4b9582a5.png",
            bg:
              "https://img13.360buyimg.com/imagetools/jfs/t1/169715/35/5534/53586/601cae21E3590420d/b815d506a54e2aa0.jpg",
          },
        ],
      },
      filter: "() => {}",
    },
  },
};
export default data;
